import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const EyeClosedIcon = (props: PosIconProps) => {
  return (
    <SvgWrapper
      {...props}
      viewBox="0 0 20 20" // The viewbox here is important as it won't display properly without this specific value
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.07011 6.41018C2.92846 6.09541 2.55845 5.95506 2.24368 6.09671C1.9289 6.23836 1.78855 6.60836 1.9302 6.92314C2.65226 8.52771 3.69977 9.7726 4.92681 10.6578L3.24507 12.9653C3.04176 13.2442 3.10308 13.6352 3.38204 13.8385C3.66099 14.0418 4.05194 13.9805 4.25524 13.7015L5.9942 11.3155C7.05635 11.8678 8.20891 12.1857 9.37515 12.2693V14.5833C9.37515 14.9285 9.65498 15.2083 10.0002 15.2083C10.3453 15.2083 10.6252 14.9285 10.6252 14.5833V12.2693C11.7915 12.1857 12.9441 11.8677 14.0063 11.3155L15.7452 13.7015C15.9485 13.9804 16.3395 14.0418 16.6184 13.8385C16.8974 13.6352 16.9587 13.2442 16.7554 12.9653L15.0736 10.6577C16.3006 9.77251 17.3481 8.52765 18.0701 6.92314C18.2118 6.60836 18.0714 6.23836 17.7566 6.09671C17.4419 5.95506 17.0719 6.09541 16.9302 6.41018C14.1513 12.5855 5.84899 12.5855 3.07011 6.41018Z"
        fill={props.fill || '#3F1D75'}
      />
    </SvgWrapper>
  );
};
